import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=a05d13be&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=ts&"
export * from "./VideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=a05d13be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05d13be",
  null
  
)

export default component.exports